/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var DownloadOutlineIcon = function DownloadOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M13 12.2217L13 3H11L11 12.4644L7.70712 9.17148L6.29291 10.5857L11.8787 16.1715L17.4644 10.5857L16.0502 9.17148L13 12.2217Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20H4V18H20V20Z"
  }));
};
export default DownloadOutlineIcon;